import React from 'react'
import { Box, CircularProgress, Divider, Fab, Typography, useTheme } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider, Chip, Tooltip } from "@mui/material";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import Header from "../components/Header";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import { api } from '../api';
import { fetchToken } from '../auth/Token';
import { useLocation } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { DataGrid, GridToolbar, gridClasses, GridRowParams, GridActionsCellItem} from '@mui/x-data-grid';
import { tokens } from '../theme';
import { FormatedDate } from '../components/SavingsDetails';
import Backdrop from '@mui/material/Backdrop';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import Modal from '@mui/material/Modal';
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from '@mui/icons-material/Refresh';
import PersonIcon from '@mui/icons-material/Person';
import {ArrowUpward} from '@mui/icons-material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import PriceChart from '../components/PriceChart';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { toast } from 'sonner';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    }));
const Itemb = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
}));

const Itembf = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#f0f0f0',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
  }));

  const Itembd = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    margin:'5px',
    color: theme.palette.text.secondary,
  }));


export const Commodities = () => {
    const [theme, colorMode] = useMode();
    const colors = tokens(theme.palette.mode);
    const location = useLocation();
    const society_id = location.state && location.state.society_id;
    const society_name = location.state && location.state.name;
    const [isSidebar, setIsSidebar] = useState(true);
    const [commodity, setCommodity] = useState([]);
    const [tracks, setTracks] = useState([]);
    const [openn, setOpenn] = useState(false);
    const [modal_openn, setModal_Openn] = useState(false);
    const [new_price, setNew_Price] = useState(null)
    const [new_price_id, setNew_Price_id] = useState(null)
    const [price_for_show, setPrice_for_show] = useState()
    const [unit_for_show, setUnit_for_show] = useState()
    const [open_mind, setOpen_mind] = useState()
    const [current_commodity, setCurrent_commodity] = useState('')
    const [load_ok, setLoad_ok] = useState(false)
    const [hold_id, setHold_id] = useState(null)
    const [price_tracked, setPrice_tracked] = useState([]);
    const [loan_products, setLoan_products] = useState([]);
    const [edit_open, setEdit_open] = useState(false);
    const [e_id, setE_Id] = useState(null);
    const [e_type, setE_Type] = useState('');
    const [e_name, setE_Name] = useState('');
    const [e_interest, setE_Interest] = useState(null);
    const [crop_id, setCrop_id] = useState(null);
    const [e_price, setE_Price] = useState(null);
    const [e_quantity, setE_Quantity] = useState(null);
    const [loading, setLoading] = useState(false);
    const [e_company, setE_Company] = useState('');

    const handleEditOpen = (id, name, type, price, crop_id, interest, quantity, company) => {
        setE_Id(id);
        setE_Name(name);
        setE_Type(type);
        setE_Price(price);
        setEdit_open(true);
        setCrop_id(crop_id);
        setE_Interest(interest);
        setE_Quantity(type === 'input'? quantity: 0);
        setE_Company(type === 'input'? company: '');
    };
    
    const handleEditClose = () => {
        setEdit_open(false);
        setE_Id(null);
        setE_Type('');
        setE_Name('')
        setE_Price(null)
        setE_Interest(null)
        setE_Quantity(null)
        setE_Company(null)
    };

    const edit_style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 420,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        '&::-webkit-scrollbar': {
            width: '7px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        bgcolor: 'background.paper',
        border: '1px solid #e7ecef',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
      };
    
    const handlePriceUpdate = (id, commodity) => {
        api.get(`/account/grade/values/${id}`, {
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
        }).then(function (response) {
            // console.log('got here')
            setPrice_for_show(response.data.grades);
            setUnit_for_show(response.data.units_kg);
            setCurrent_commodity(commodity);
            setHold_id(id);
            handleShow(commodity);
            fetchLoanProducts();
        }).catch(function (error){
            console.log(error)
        })
    }

    const fetchLoanProducts = () => {
        if(hold_id){
            api.get(`/association/production/loan/view/one/${hold_id}`, {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response) {
                setLoan_products(response.data);
            }).catch(function (error){
                console.log(error)
            })
        }
        
    }
    // useEffect(() => {
    //     if(hold_id){
    //         fetchLoanProducts();
    //     }
    // },[])


    

    const modal_close = () => {
        setModal_Openn(false)
    }

    const handleCloss = () => {
      setOpenn(false);
    };
    const handleOpen = () => {
      setOpenn(true);
    };

    const handle_price_changing = (newPrice, id) => {
        setNew_Price(newPrice);
        setNew_Price_id(id);
    }

    const handle_price_change = () => {
        setLoad_ok(true);
        const data = new FormData();
        data.append('id', new_price_id)
        data.append('new_price', new_price)

        api.post('/commodity/price/change', data, {
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
        }).then(function (response){
            toast.success(response.data);
        }).catch(function (error){
            console.log(error)
        }).finally(function(){
            setLoad_ok(false);
        })
    }

    const sec_style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 620,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        bgcolor: 'background.paper',
        border: '1px solid #e7ecef',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
      };



        const fetchTracks = () =>{
            api.get(`/commodity/prices/track/${society_id}`,  {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response){
                setTracks(response.data?.Tracks);
            }).catch(function (error){
                console.log(error)
            })
        };

    useEffect(()=>{
        fetchTracks();
    },[])

    const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
      });
    // console.log(tracks);

    const tracksColumns = [
        {
            field: "id",
            headerName: "Id",
            flex:1,
        },
        {
            field: "commodity",
            headerName: "Commodity",
            flex:1,
            Width: 100
        },
        {
            field: "date",
            headerName: 'DateTime',
            type: 'dateTime',
            flex: 1,
            Width: 500,
            valueGetter: ({ value }) => value && new Date(value),
            renderCell:(params) => <FormatedDate value={params.row.date}/>
        },
        {
            field: "grade",
            headerName: "Grade",
            flex:1,
            Width: 100
        },
        {
            field: "new_price_per_kg",
            headerName: "Price",
            flex:1,
            Width: 50,
            renderCell:(params) => currencyFormat.format(params.row.new_price_per_kg)
        },
    ]


        const handleClose = (event, reason) => {
            if (reason === 'clickaway') {
              return;
            }
            setOpen(false);
        };

        const action = (
            <React.Fragment>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </React.Fragment>
          );

        const fetch_com = () => {
            api.get(`/commodity/type/commodities/${society_id}`, {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response){
                setCommodity(response.data?.Commodities);
            }).catch(function (error){
                console.log(error);
            })
        }


        useEffect(() => {
            fetch_com()
        },[])

            
        const formiik = useFormik({
            initialValues: {
                commodity: "",
                unit_per_kg: [],
                grade: ["Grade A", "Grade B", "Grade C"],
                price_per_kg: [],
                society_id: society_id
            },
            validationSchema: Yup.object({
                commodity: Yup.string()
                    .required('Commodity Name cannot be empty'),
                // price_per_kg: Yup.string()
                //     .required('Must not be empty')
                //     .test('maxCommas', 'Maximum of three prices, each for a Grade as specified above', (value) => {
                //         if (!value) return true;
                //         const commaCount = (value.match(/,/g) || []).length;
                //         return commaCount <= 2;
                //         })
                //     .test('validValues', 'Empty values between commas are not allowed', (value) => {
                //         if (!value) return true;
                //         const parts = value.split(',');
                //         return parts.every((part) => part.trim() !== '');
                //         }),
            }),
            onSubmit: (values) => {
                handleOpen()
                api.post('/commodity/create/commodity', values , {
                    headers: {
                        Authorization:'Bearer ' + fetchToken(),
                    },
                }).then(function (response) {
                    if(response.data === "Commodity already exists"){
                        toast.warning(response.data)
                    }else{
                        toast.success(response.data)
                        formiik.handleReset()
                        fetchTracks();
                        fetch_com()
                    }
                }).catch(function (error){
                    console.log(error)
                }).finally(function (){
                    handleCloss();
                })
            }
        })



    
        


        const originalTracks = [...tracks];
        const seenRows = {};
        const uniqueTracks = [];

        for (const track of originalTracks) {
            const rowIdentifier = `${track.commodity}-${track.date}-${track.grade}-${track.new_price_per_kg}`;
            
            if (!seenRows[rowIdentifier]) {
              seenRows[rowIdentifier] = true;
              uniqueTracks.push(track);
            }
        }
        const RefreshDem = () => {
            handlePriceUpdate(hold_id, current_commodity)
        }

        const fetch_all_prices = () => {
            api.get(`/commodity/price/track/intelligence/${hold_id}`,{
              headers: {
                Authorization: 'Bearer ' + fetchToken()
              }
            }).then(function (response){
                setPrice_tracked(response.data?.prices);
            }).catch(function (error){
              console.log(error)
            })
        }

        useEffect(()=>{
            fetch_all_prices()
        },[unit_for_show])

        const [chartData_a, setChartData_a] = useState([]);
        const [chartData_b, setChartData_b] = useState([]);
        const [chartData_c, setChartData_c] = useState([]);
        
        const [priceData, setPriceData] = useState({
            commodity_name: current_commodity,
            grade: "Grade A"
          });

        const changeChart = (grade) => {
            setPriceData({
                commodity_name: current_commodity,
                grade: grade
            })
        }

        const fetch_chart_data = () => {
            api.get(`/account/chart/price/${hold_id}`,{
              headers: {
                Authorization: 'Bearer ' + fetchToken()
              }
            }).then(function (response){
              setChartData_a(response.data?.Grade_A);
              setChartData_b(response.data?.Grade_B);
              setChartData_c(response.data?.Grade_C);
            }).catch(function (error){
              console.log(error)
            })
          }
            useEffect(()=>{
                if(hold_id){
                    fetch_chart_data();
                    const intervalId = setInterval(fetch_chart_data, 2000);
                    return () => clearInterval(intervalId);
                }
            },[hold_id])

            const removeThing = (id, type) => {
                const data = new FormData()
                data.append('id', id)
                data.append('typee', type)
        
                api.post('/association/production/loan/delete/service/input', data, {
                    headers: {
                        Authorization:'Bearer ' + fetchToken(),
                    },
                }).then(function (response){
                    toast.success(response.data);
                    fetchLoanProducts();
                }).catch(function (error){
                    console.log(error);
                })
            }

        const handleShow = (commodity) => {
            price_for_show?
            setOpen_mind(
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                        <Typography sx={{ mb:'7px' }} textAlign='center' variant='h4' fontStyle='normal' 
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{commodity?commodity:current_commodity}</b></Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography >Update Price <IconButton onClick={()=>setModal_Openn(true)}><PriceChangeOutlinedIcon /></IconButton> </Typography>
                            <div style={{ display: 'block', margin:1 }}>
                                <Typography fontStyle='italic' variant="h6" ><b>Price</b> <IconButton onClick={RefreshDem}><RefreshIcon /></IconButton></Typography>
                                {
                                price_for_show && price_for_show.map((item)=>(
                                        <Chip
                                            key={item.id}
                                            label={<b><i>{`${item.grade}: ${currencyFormat.format(item.price_per_kg)}/kg`}</i></b>}
                                            size='small'
                                            variant='outlined'
                                            sx={{ color:'#000',m:1 }}

                                        />
                                ))
                                }
                            </div>
                            <div style={{ display: 'block', margin:2 }}>
                                <Typography fontStyle='italic' variant="h6" ><b>Units</b></Typography>
                                {
                                    unit_for_show && unit_for_show.map((item)=>(
                                        <Chip
                                            key={item.id}
                                            label={<b><i>{`${item.unit_per_kg}kg`}</i></b>}
                                            size='small'
                                            variant='outlined'
                                            sx={{ color:'#000',m:1 }}
                                        />
                                ))
                                }
                            </div>
                    </Grid>

                    
                        {
                            loan_products?
                            <Grid item xs={12} md={6} sx={{ maxHeight: 200, borderLeftStyle:'groove',borderLeftColor:'black', borderRadius:7, overflowY: 'auto', '&::-webkit-scrollbar': {
                                width: '7px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: '#f1f1f1',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: '#888',
                                    borderRadius: '10px',
                                },
                                '&::-webkit-scrollbar-thumb:hover': {
                                    background: '#555',
                            } }}>
                                <Typography sx={{ color:'#22223b', textAlign:'center' }} variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{commodity?commodity:current_commodity} Loan Products</b>
                                </Typography>
                                <ul><Typography sx={{ color:'#22223b', textDecoration:'underline' }} variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Services setups</b>
                                <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(null, '', 'service', null, hold_id, null, null, '')} variant="contained">Add service</Button>
                                </Typography>
                                            {
                                            loan_products?.services?.map((service) =>(
                                                <li>
                                                    <Typography sx={{ color:'#000' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>{service.service}: {currencyFormat.format(service.service_price_per_acre)} per acre | {service.interest_percentage_rate_anum}% interest rate/anum </b> 
                                                        <IconButton  onClick={() => removeThing(service.id, 'service')}><RemoveCircleIcon /></IconButton>
                                                        <Button sx={{ m:1, backgroundColor:'#eb5e28', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(service.id, service.service, 'service', service.service_price_per_acre, hold_id, service.interest_percentage_rate_anum, null, '')} variant="contained">Edit</Button>
                                                    </Typography>
                                                    <Divider variant='middle' />
                                                </li>
                                            ))
                                        }
                                    </ul>
                                    <ul><Typography sx={{ color:'#22223b', textDecoration:'underline' }} variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Inputs setups</b>
                                    <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(null, '', 'input', null, hold_id, null, null, '')} variant="contained">Add Input</Button>
                                    </Typography>
                                    
                                        {
                                            loan_products?.inputs?.map((input) =>(
                                                <li>
                                                    <Typography sx={{ color:'#000' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>({input.company}) {input.input}: {currencyFormat.format(input.input_price_per_acre)} per acre | {input.interest_percentage_rate_anum}% interest rate/anum | {input.quantity_per_acre} (g/kg/liters/bottle) per acre </b>
                                                        <IconButton  onClick={() => removeThing(input.id, 'input')}><RemoveCircleIcon /></IconButton>
                                                        <Button sx={{ m:1, backgroundColor:'#eb5e28', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(input.id, input.input, 'input', input.input_price_per_acre, hold_id, input.interest_percentage_rate_anum, input.quantity_per_acre, input.company)} variant="contained">Edit</Button>
                                                    </Typography>
                                                    <Divider variant='middle' />
                                                </li>
                                            ))
                                        }
                                    </ul>   
                                    <ul><Typography sx={{ color:'#22223b', textDecoration:'underline' }} variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Equipments setups</b>
                                    <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(null, '', 'equipment', null, hold_id, '')} variant="contained">Add Equipment</Button>
                                    </Typography>
                                    
                                        {
                                            loan_products?.equipments?.map((equipment) =>(
                                                <li>
                                                    <Typography sx={{ color:'#000' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>{equipment.equipment}: {currencyFormat.format(equipment.equipment_price_per_acre)} per acre | {equipment.interest_percentage_rate_anum}% interest rate/anum</b>
                                                        <IconButton  onClick={() => removeThing(equipment.id, 'equipment')}><RemoveCircleIcon /></IconButton>
                                                        <Button sx={{ m:1, backgroundColor:'#eb5e28', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(equipment.id, equipment.equipment, 'equipment', equipment.equipment_price_per_acre, hold_id, equipment.interest_percentage_rate_anum, '')} variant="contained">Edit</Button>
                                                    </Typography>
                                                    <Divider variant='middle' />
                                                </li>
                                            ))
                                        }
                                    </ul>   
                                </Grid>
                            : 
                            <>
                                <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(null, '', 'service', null, hold_id, null, null, '')} variant="contained">Setup Loan Service</Button>
                                <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(null, '', 'input', null, hold_id, null, null, '')} variant="contained">Setup Loan Input</Button>
                                <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={() =>handleEditOpen(null, '', 'equipment', null, hold_id, null, null, '')} variant="contained">Setup Loan Input</Button>
                            </>
                            
                        }
                            

                    <Grid item xs={12} md={12}>
                        <Typography variant="h5" fontStyle='oblique' textAlign='center'>Tracks</Typography>
                        <Box sx={{ display:'flex' }}>
                            <Typography sx={{mr:14, ml:2}}><b>DateTime</b></Typography>
                            <Typography sx={{mr:8}}><b>Grade</b></Typography>
                            <Typography sx={{mr:6}}><b>Movement</b></Typography>
                            <Typography sx={{mr:8}}><b>Price</b></Typography>
                            <Typography sx={{mr:2}}><b>Percentage</b></Typography>
                            <Typography sx={{mr:4}}><b>Intavals</b></Typography>
                            <IconButton onClick={fetch_all_prices}><RefreshIcon /></IconButton>
                        </Box>
                        <Box style={{ overflowY:'auto',maxHeight:'120px' }}>
                        {
                            price_tracked.map((item) => (
                            <Itembd>
                                <Box sx={{ display:'flex'}}>
                                <Typography sx={{mr:5}}><b><FormatedDate value={item.date} /></b></Typography>
                                <Typography sx={{mr:10}}><b>{item.grade}</b></Typography>
                                <Typography sx={{mr:8}} color={item.movement ==="Increased"? 'green':item.movement ==="Decreased"?'red': "black"}>
                                    <b>
                                    {item.movement ==="Increased"? <ArrowUpward/>: item.movement ==="Decreased"? <ArrowDownwardIcon />:<IndeterminateCheckBoxOutlinedIcon />}
                                    </b>
                                </Typography>
                                
                                <Typography sx={{mr:9}} color={item.movement ==="Increased"? 'green':item.movement ==="Decreased"?'red': "black"}>
                                <b>{currencyFormat.format(item.price)}</b>
                                </Typography>

                                <Typography sx={{mr:4}} color={item.movement ==="Increased"? 'green':item.movement ==="Decreased"?'red': "black"}>
                                <b>{item.percentage_on_movement}%</b>
                                </Typography>

                                <Typography sx={{mr:0}} color={item.movement ==="Increased"? 'green':item.movement ==="Decreased"?'red': "black"}>
                                <b>{item.date_difference} {item.date_difference <= 1? "day":"days"}</b>
                                </Typography>
                                </Box>
                            </Itembd>
                            ))
                        }
                        </Box>
                    </Grid>
        <Modal
            open={edit_open}
            onClose={handleEditClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={edit_style}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <Typography
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            variant='h5'
                            textAlign='center'
                        >
                            <b>Loan Product</b>
                        </Typography>
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <TextField 
                            size='small'
                            value={e_name}
                            name='e_name'
                            label={e_type === 'service'? 'Service loan name':e_type === 'input'? 'Input loan name': 'Equipment name'}
                            onChange={e => setE_Name(e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField 
                            size='small'
                            value={e_price}
                            name='e_price'
                            label={e_type === 'service'? 'Service loan price charged/acre':e_type === 'input'? 'Input loan price charged/acre': 'Equipment loan price charged/acre'}
                            onChange={e => setE_Price(e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField 
                            size='small'
                            value={e_interest}
                            name='e_price'
                            label={e_type === 'service'? 'Service interest rate/anum':e_type === 'input'? 'Input interest rate/anum': 'Equipment interest rate/anum'}
                            onChange={e => setE_Interest(e.target.value)}
                        />
                    </Grid>

                    {
                        e_type === 'input'?
                        <>
                        <Grid item xs={12} md={6}>
                        <TextField 
                            size='small'
                            value={e_quantity}
                            name='e_quantity'
                            label={`Number of ${e_name}/acre`}
                            onChange={e => setE_Quantity(e.target.value)}
                        />
                        </Grid>

                        <Grid item xs={12} md={6}>
                        <TextField 
                            size='small'
                            value={e_company}
                            name='e_company'
                            label='Source company'
                            onChange={e => setE_Company(e.target.value)}
                        />
                        </Grid>
                        </>
                    :
                    null
                    }
                    
                    <Grid item xs={12} md={12}>
                        <Button sx={{ m:1, backgroundColor:'#660708', borderRadius:4 }} size="small" onClick={handleEditClose} variant="contained">Cancel</Button>
                        <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" onClick={SaveEdit} variant="contained">{loading? <CircularProgress size={20}/> :'Save'}</Button>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
                        
                </Grid>
            )
            : <Typography variant='subtitle' fontStyle='Italic' sx={{m:1}}><b style={{color:'black'}}>Select commodity for details</b></Typography>
        }

        useEffect(()=>{
            handleShow()
        },[handlePriceUpdate])

        const SaveEdit = () => {
            if(e_id){
                const data = new FormData()
                data.append('id', e_id)
                data.append('name', e_name)
                data.append('typee', e_type)
                data.append('price', e_price)
                data.append('interest', e_interest)
                data.append('quantity', e_quantity)
                data.append('company', e_company)
                setLoading(true);
                api.post('/association/production/loan/edit/service/input', data, {
                    headers: {
                        Authorization:'Bearer ' + fetchToken(),
                    },
                }).then(function (response){
                    toast.success(response.data);
                    fetchLoanProducts();
                    handleEditClose();
                }).catch(function (error){
                    console.log(error);
                }).finally(function () {
                    setLoading(false)
                })
            }else{
                const data = new FormData()
                data.append('crop_id', crop_id)
                data.append('name', e_name)
                data.append('typee', e_type)
                data.append('price', e_price)
                data.append('interest', e_interest)
                data.append('quantity', e_quantity)
                data.append('company', e_company)
                if(!e_price || !e_interest){
                    toast.warning('Fields must not be empty');
                }else{
                    setLoading(true);
                    api.post('/association/production/loan/add/service/input', data, {
                        headers: {
                            Authorization:'Bearer ' + fetchToken(),
                        },
                    }).then(function (response){
                        toast.success(response.data);
                        fetchLoanProducts();
                        handleEditClose();
                    }).catch(function (error){
                        console.log(error);
                    }).finally(function () {
                        setLoading(false)
                    })
                }
                
            }
            
        }

   

  return (
      <div className="app">
        <main className="content">
            <Box sx={{ m:5 }}>
              {/* HEADER */}
              <Box display="flex" justifyContent="space-between" alignItems="center">
              <Header title="Commodities" subtitle="Manage All Commodities" />
              </Box>
                <Box style={{ borderRadius:"20px", color: "#09101f", boxShadow:"15px", padding: "15px"}}>
                    <Typography variant="h4" gutterBottom>
                        Manage Commodities
                </Typography>
                       
                       <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <Item>
                                    <form onSubmit={formiik.handleSubmit}>
                                        <Grid item md={12}>
                                            <TextField
                                                margin="dense"
                                                id="commodity"
                                                name="commodity"
                                                label="Commodity Name"
                                                onChange={formiik.handleChange}
                                                type="text"
                                                value={formiik.values.commodity}
                                                onBlur={formiik.handleBlur}
                                                error={formiik.touched.commodity && Boolean(formiik.errors.commodity)}
                                                helperText={formiik.touched.commodity && formiik.errors.commodity}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>
                                        <Grid item md={12}>
                                            <TextField
                                                // margin="dense"
                                                required
                                                id="unit_per_kg"
                                                name="unit_per_kg"
                                                label="Units/kg (separate with a comma[,])"
                                                onChange={(e) => {
                                                    const newValue = e.target.value.split(",").map((part) => part.trim());
                                                    formiik.setFieldValue("unit_per_kg", newValue);
                                                }}
                                                value={formiik.values.unit_per_kg.join(", ")}
                                                onBlur={formiik.handleBlur}
                                                error={formiik.touched.unit_per_kg && Boolean(formiik.errors.unit_per_kg)}
                                                helperText={formiik.touched.unit_per_kg && formiik.errors.unit_per_kg}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>
                                        <Grid item md={12}>
                                            <TextField
                                                margin="dense"
                                                id="price_per_kg"
                                                name="price_per_kg"
                                                label="Price/kg (Grade A, Grade B, Grade C)"
                                                onChange={(e) => {
                                                    const newValu = e.target.value.split(",").map((part) => part.trim());
                                                    formiik.setFieldValue("price_per_kg", newValu);
                                                }}
                                                value={formiik.values.price_per_kg.join(", ")}
                                                onBlur={formiik.handleBlur}
                                                error={formiik.touched.price_per_kg && Boolean(formiik.errors.price_per_kg)}
                                                helperText={formiik.touched.price_per_kg && formiik.errors.price_per_kg}
                                                fullWidth
                                                variant="outlined"
                                            />

                                        </Grid>
                                        <Button variant='contained' color='success' type='submit'>Add</Button>
                                        <Button sx={{ marginLeft: '10px', backgroundColor:'red' }} variant='contained' onClick={() => formiik.handleReset()}>Cancel</Button>
                                    </form>
                                </Item>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Itemb>
                                    <Typography variant='h4' textAlign='center'>{society_name}'s Commodities</Typography>
                                    <Typography variant='subtitle' fontStyle='Italic' sx={{m:1}}><b style={{color:'black'}}>Double click on commodity to view details</b></Typography>
                                    <Box 
                                        display='flex'
                                        sx={{ overflowX: 'auto', maxWidth:'550px' }}
                                        marginTop='5px'
                                    >
                                        {
                                            commodity?
                                            commodity.map((item)=>(
                                                <Chip key={item.id} label={item.commodity} sx={{ m:1, borderRadius:2 }} onClick={() => handlePriceUpdate(item.id, item.commodity)} />
                                            ))
                                            :<Typography variant='subtitle' fontStyle='Italic'>Commodities in Society will appear here there is any</Typography>
                                        }
                                    </Box>
                                    <Divider variant='middle' />
                                        {open_mind}
                                </Itemb>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                {
                                    current_commodity && current_commodity?
                                    <Box sx={{ height: 450 }}>
                                        {
                                            priceData?
                                            <PriceChart chartData={priceData.grade === "Grade A"?chartData_a:priceData.grade === "Grade B"?chartData_b:chartData_c} priceData={priceData} />:
                                            <Box sx={{ m:10 }}>
                                            <CircularProgress size={25} />
                                            </Box>
                                        }
                                        <Tooltip title="Select Grade to view chart">
                                            <Box>
                                            <Chip label="Grade A" onClick={() => changeChart("Grade A")} size='small' variant='outlined' sx={{ backgroundColor:'#0b525b', color:'#fff',mb:'2px', borderRadius:2 }} />
                                            <Chip label="Grade B" onClick={() => changeChart("Grade B")} size='small' variant='outlined' sx={{ backgroundColor:'#0b525b', color:'#fff',mb:'2px', borderRadius:2 }} />
                                            <Chip label="Grade C" onClick={() => changeChart("Grade C")} size='small' variant='outlined' sx={{ backgroundColor:'#0b525b', color:'#fff',mb:'2px', borderRadius:2 }} />
                                            </Box>
                                        </Tooltip>
                                    </Box>
                                    :
                                    null
                                }
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Item>
                                    <Box
                                        m="40px 0 0 0"
                                        height="105vh"
                                        paddingBottom="35px"
                                    >
                                        <Typography variant='h3' sx={{ marginBottom:'10px' }}>Previous Prices</Typography>
                                    <Box sx={{ display:'flex' }}>
                                            <Typography sx={{mr:14, ml:2}}><b>Commodity</b></Typography>
                                            <Typography sx={{mr:14}}><b>DateTime</b></Typography>
                                            <Typography sx={{mr:8}}><b>Grade</b></Typography>
                                            <Typography sx={{mr:6}}><b>Movement</b></Typography>
                                            <Typography sx={{mr:8}}><b>Price</b></Typography>
                                            <Typography sx={{mr:4}}><b>Percentage</b></Typography>
                                            <Typography sx={{mr:4}}><b>Intavals</b></Typography>
                                            <IconButton onClick={fetchTracks}><RefreshIcon /></IconButton>
                                        </Box>
                                        <Box style={{ overflowY:'auto',maxHeight:'430px' }}>
                                            {
                                                tracks.map((item) => (
                                                <Itembd>
                                                <Box sx={{ display:'flex'}}>
                                                    <Typography sx={{mr:10}}><b>{item.commodity}</b></Typography>
                                                    <Typography sx={{mr:12}}><b><FormatedDate value={item.date} /></b></Typography>
                                                    <Typography sx={{mr:10}}><b>{item.grade}</b></Typography>
                                                    <Typography sx={{mr:8}} color={item.movement ==="Increased"? 'green':item.movement ==="Decreased"?'red': "black"}>
                                                    <b>
                                                        {item.movement ==="Increased"? <ArrowUpward/>: item.movement ==="Decreased"? <ArrowDownwardIcon />:<IndeterminateCheckBoxOutlinedIcon />}
                                                    </b>
                                                    </Typography>
                                                    
                                                    <Typography sx={{mr:9}} color={item.movement ==="Increased"? 'green':item.movement ==="Decreased"?'red': "black"}>
                                                    <b>{currencyFormat.format(item.price)}</b>
                                                    </Typography>

                                                    <Typography sx={{mr:7}} color={item.movement ==="Increased"? 'green':item.movement ==="Decreased"?'red': "black"}>
                                                    <b>{item.percentage_on_movement}%</b>
                                                    </Typography>

                                                    <Typography sx={{mr:0}} color={item.movement ==="Increased"? 'green':item.movement ==="Decreased"?'red': "black"}>
                                                    <b>{item.date_difference} {item.date_difference <= 1? "day":"days"}</b>
                                                    </Typography>
                                                </Box>
                                                </Itembd>
                                            ))
                                            }
                                            
                                        </Box>
                                    </Box>
                                </Item>
                            </Grid>

                       </Grid>

                       <Modal
                            open={modal_openn}
                            onClose={modal_close}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={sec_style}>
                                 <div>
                                        {
                                            price_for_show && price_for_show.map((item) => (
                                                <div key={item.id} style={{ display:'flex' }}>
                                                    <Typography sx={{ m:1 }} variant='h5' fontStyle='oblique'>{item.grade}</Typography>
                                                    <TextField 
                                                        size='small'
                                                        defaultValue={item.price_per_kg}
                                                        sx={{ m:1 }}
                                                        name='new_price'
                                                        onChange={(e) => handle_price_changing(e.target.value, item.id)}
                                                    />
                                                    {
                                                        load_ok === true?
                                                        <CircularProgress size={30} color="success" />
                                                        :
                                                        <IconButton onClick={handle_price_change} sx={{ m:1 }}><SaveIcon fontSize='large' color="success"/></IconButton>
                                                    }
                                                </div>
                                            ))
                                        }
                                 </div>
                                 <Button size='medium' color='secondary' onClick={modal_close} variant="contained">Done</Button>
                            </Box>
                        </Modal>      


                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={openn}
                            onClick={handleCloss}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>

                </Box>
            </Box>
          </main>
            </div>
  )
}